// import { InjectedConnector } from "@web3-react/injected-connector";
// APP TEXT
export const APP_TITLE = "EcoFutures";

// UI CONSTANTS
export const FOOTER_HEIGHT = 72;
export const HEADER_HEIGHT = 60;
export const DRAWER_WIDTH = 250;
// APP THEME
export const DARK_MODE_THEME = "dark";
export const LIGHT_MODE_THEME = "light";

export const CURRENCY_NAME = "USD";
export const TREE_CURRENCY = "TR3";

export const TERM_UNIT: "days" | "years" = "days";

// Time unit in seconds - controls how contract periods are calculated
// Production: 1 year = 31,556,926 seconds
// export const TIME_UNIT_SECONDS = 31556926;
// Testnet (Accelerated): 1 "year" = 1 day = 86,400 seconds
export const TIME_UNIT_SECONDS = 86400;

// Seconds per day - used for daily mint rate calculations
// Production: 1 day = 86,400 seconds
// Testnet (Accelerated): also 86,400 — Tree._rewardInterval is 86,400 (1 real day = 1 contract
// year), so a claim lands once a real day on both configs and the daily rate is the claim rate.
export const SECONDS_PER_DAY = 86400;

// Display unit for moment.js duration calculations
// Production: "years" - contract periods are in years
// export const TIME_DISPLAY_UNIT: "days" | "years" = "years";
// Testnet (Accelerated): "days" - contract periods are in days
export const TIME_DISPLAY_UNIT: "days" | "years" = "days";

// Re-verification interval - how often lands need to be re-verified
// Production: 182 days (approximately half a year)
// export const VERIFICATION_INTERVAL_VALUE = 182;
// export const VERIFICATION_INTERVAL_UNIT: "days" | "hours" = "days";
// Testnet (Accelerated): 12 hours (half of 1 day, since 1 year = 1 day)
export const VERIFICATION_INTERVAL_VALUE = 12;
export const VERIFICATION_INTERVAL_UNIT: "days" | "hours" = "hours";

// Halving Configuration — cumulative land size (in parcels) at which each edition ENDS.
//
// These are NOT the "Σ fib(i) × 2 × SF / i" figures the older comments quoted; that formula does
// not describe the deployed Tree. Read off the live accelerated contract (0x50a5…84b1) on
// 2026-07-31 by probing currentFibByLandSize() for every edition boundary, the thresholds are
//
//   threshold(n) = fib(n) × fib(n+1) × 1,000,000 parcels
//
// and the per-edition mint rate is 100,000,000 / fib(n) — there is no 2× multiplier from Ed 7 on.
// Confirmed against halvingSequenceByLandSize() for all 12 editions.
//
// _halvingScaleFactor is 100 on the accelerated testnet (1,000,000 in production), but the
// thresholds above do not scale from it in the way the old comment assumed, so do not recompute
// them — if the scale factor is ever retuned, re-probe the contract. For "how much land until the
// next halving", Tree.nextHalvingLandSize() is the authoritative live value (1,000,000 today).
export const HALVING_THRESHOLD_PARCELS = 1000000; // Edition 1 cumulative threshold
export const HALVING_THRESHOLDS = [
  1000000, // Ed 1:  fib=1×1     cumul=1,000,000      - Rate: 100,000,000
  2000000, // Ed 2:  fib=1×2     cumul=2,000,000      - Rate: 100,000,000
  6000000, // Ed 3:  fib=2×3     cumul=6,000,000      - Rate:  50,000,000
  15000000, // Ed 4:  fib=3×5     cumul=15,000,000     - Rate:  33,333,333
  40000000, // Ed 5:  fib=5×8     cumul=40,000,000     - Rate:  20,000,000
  104000000, // Ed 6:  fib=8×13    cumul=104,000,000    - Rate:  12,500,000
  273000000, // Ed 7:  fib=13×21   cumul=273,000,000    - Rate:   7,692,307
  714000000, // Ed 8:  fib=21×34   cumul=714,000,000    - Rate:   4,761,904
  1870000000, // Ed 9:  fib=34×55   cumul=1,870,000,000  - Rate:   2,941,176
  4895000000, // Ed 10: fib=55×89   cumul=4,895,000,000  - Rate:   1,818,181
  12816000000, // Ed 11: fib=89×144  cumul=12,816,000,000 - Rate:   1,123,595
  33552000000, // Ed 12: fib=144×233 cumul=33,552,000,000 - Rate:     694,444
  // Ed 12's boundary is never crossed — _maxFibonacciCounter caps the counter at 12.
];

export const DATE_TIME_FORMAT = "DD MMM YYYY HH:mm";

export const DATE_FORMAT = "Do MMM YYYY";

// export const injected = new InjectedConnector({ supportedChainIds: [1, 42, 1337, 80001] });
// export const MainChainID = 11155111;
export const MainChainID = 97;

export const ButtonHeight = "54px";

export enum EcoTokenStatus {
  UPLOADED = "uploaded", // token was uploaded by user
  // // token record was created by user
  // CREATED = "created", //uploaded

  DRAFT = "draft", // token is in draft state , SAVE on upload process

  VERIFICATION_REQUIRED = "verification_required", // token verification is required
  // // token verification was requested
  // VERIFICATION_REQUESTED = "verification_requested", // verification required

  REJECTED = "rejected", // token verification was rejected by trust

  CLAIMED = "claimed", // token claimed for verification by trust
  // // token claimed for verification by trust
  // VERIFICATION = "verification", // claimed

  VERIFICATION_FAILED = "verification_failed", // trust fully declined minting  || return to draft state with error message
  // // trust fully declined minting
  // DENIED = "denied",

  VERIFICATION_PREPARED = "verification_prepared", // token verification is prepared
  // // token verification was prepared
  // APPROVAL_PREPARED = "approval_prepared",

  APPROVED = "approved", // token was approved by trust
  // // token verification was approved
  // APPROVED = "approved",

  VERIFIED = "verified", // token was verified by trust and minted by guardian
  // // token minted
  // MINTED = "minted", // verified

  BLOCKED = "blocked", // token was blocked by trust
  // // token was blocked by trust
  // BLOCKED = "blocked",

  INVALIDATED = "invalidated", // token was invalidated
  // // token was cancelled by admin
  // CANCELLED = "cancelled",\

  // // token deleted by user
  // DELETED = "deleted",

  RE_VERIFICATION_REQUIRED = "re_verification_required", // token re-verification is required
  // // token is on re-verification
  // RE_VERIFICATION = "re_verification", // verification required

  LISTED_TO_SALE = "listed_to_sale", // token is listed for sale

  REASSIGNMENT_REQUIRED = "reassignment_required", // token reassignment is required
  REASSIGNMENT_PENDING = "reassignment_pending", // token reassignment is pending
  REASSIGNMENT_APPROVED = "reassignment_approved", // token reassignment is approved
}

export const onReassignment = (status: EcoTokenStatus) =>
  [
    EcoTokenStatus.REASSIGNMENT_REQUIRED,
    EcoTokenStatus.REASSIGNMENT_PENDING,
    EcoTokenStatus.REASSIGNMENT_APPROVED,
  ].includes(status);

export const onVerification = (status: EcoTokenStatus) =>
  [
    // EcoTokenStatus.VERIFICATION_REQUIRED,
    EcoTokenStatus.RE_VERIFICATION_REQUIRED,
    EcoTokenStatus.CLAIMED,
    EcoTokenStatus.VERIFICATION_PREPARED,
  ].includes(status);

export enum EtTransactionType {
  // bid placed
  BID = "bid",
  // token minted
  MINTED = "easement_added", //verified
  // token transferred
  TRANSFER = "transfer_easement",
  // auction cancelled
  CANCELLED = "auction_cancelled", // auction cancelled
  // auction created
  LISTED = "auction_created", // auction created
  // auction ended
  AUCTION_END = "end_auction", // auction ended
  // tree claimed
  REWARD_CLAIMED = "reward_claimed", // currency minted
  // token re-verified
  UPDATED = "easement_updated", // verified (re-verified)
  // auction ended without winner
  // funds distributed after verification or sale
  CLAIM_FUNDS = "usdt_claimed", // funds redeemed
  // offer accepted
  ACCEPT_OFFER = "offer_accepted", // sold
  // offer withdrawn
  OFFER_WITHDRAWN = "offer_withdrawn",
  // listed to offer
  LISTED_TO_OFFER = "listed_to_offer", // relisted
  // offer cancelled
  OFFER_CANCELLED = "offer_cancelled", // delisted

  OFFER_PLACED = "offer_placed", // offer placed

  // TRUST_ROLE_GRANTED = "user_trust_granted", // trust role granted

  TRUST_ROLE_GRANTED = "user_verifier_granted",

  TRUST_FLAGGED_FOR_DISMISSAL = "trust_flagged_for_dismissal", // trust role flagged for dismissal

  REASSIGN_LAND = "reassign_land", // land reassigned

  TRUST_DISMISSED = "trust_dismissed",

  // TRUST_ADMIN_ADDED = "trust_admin_added",

  TRUST_ADMIN_ADDED = "holder_added",

  GLOBAL_ADMIN_ADDED = "gta_added",

  GUARDIAN_UPDATE_APPROVED = "guardian_updated",

  // verification escrow paid deed_attested
  VERIFICATION_FUNDS_RELEASED = "verification_funds_released",

  // V9.1 EcoBank settlement state machine — one row per transition
  KYC_CONFIRMED = "kyc_confirmed", // buyer KYC confirmed by the bound verifier
  DEED_ANCHORED = "deed_anchored", // wet-ink deed hash anchored on chain
  DEED_ATTESTED = "deed_attested", // deed attested, withhold window opens
  SETTLEMENT_FINALISED = "settlement_finalised", // withhold elapsed, settlement closed
  DEED_CHALLENGE_DISMISSED = "deed_challenge_dismissed",
  DEED_CHALLENGED = "deed_challenged",
  REFUND_AND_RELISTED = "refund_and_relisted",
  DEED_CHALLENGE_UPHELD = "deed_challenge_upheld",
  // outcome of an off-chain deed check
  DEED_CHECK_OUTCOME = "deed_check_outcome",
}

export const COUNTRY_CODES = [
  {
    name: "International",
    countryCode: 0,
    abv: "INT",
  },
  {
    name: "Afghanistan",
    countryCode: 4,
    abv: "AF",
  },
  {
    name: "Åland Islands",
    countryCode: 248,
    abv: "AX",
  },
  {
    name: "Albania",
    countryCode: 8,
    abv: "AL",
  },
  {
    name: "Algeria",
    countryCode: 12,
    abv: "DZ",
  },
  {
    name: "American Samoa",
    countryCode: 16,
    abv: "AS",
  },
  {
    name: "Andorra",
    countryCode: 20,
    abv: "AD",
  },
  {
    name: "Angola",
    countryCode: 24,
    abv: "AO",
  },
  {
    name: "Anguilla",
    countryCode: 660,
    abv: "AI",
  },
  {
    name: "Antarctica",
    countryCode: 10,
    abv: "AQ",
  },
  {
    name: "Antigua and Barbuda",
    countryCode: 28,
    abv: "AG",
  },
  {
    name: "Argentina",
    countryCode: 32,
    abv: "AR",
  },
  {
    name: "Armenia",
    countryCode: 51,
    abv: "AM",
  },
  {
    name: "Aruba",
    countryCode: 533,
    abv: "AW",
  },
  {
    name: "Australia",
    countryCode: 36,
    abv: "AU",
  },
  {
    name: "Austria",
    countryCode: 40,
    abv: "AT",
  },
  {
    name: "Azerbaijan",
    countryCode: 31,
    abv: "AZ",
  },
  {
    name: "Bahamas",
    countryCode: 44,
    abv: "BS",
  },
  {
    name: "Bahrain",
    countryCode: 48,
    abv: "BH",
  },
  {
    name: "Bangladesh",
    countryCode: 50,
    abv: "BD",
  },
  {
    name: "Barbados",
    countryCode: 52,
    abv: "BB",
  },
  {
    name: "Belarus",
    countryCode: 112,
    abv: "BY",
  },
  {
    name: "Belgium",
    countryCode: 56,
    abv: "BE",
  },
  {
    name: "Belize",
    countryCode: 84,
    abv: "BZ",
  },
  {
    name: "Benin",
    countryCode: 204,
    abv: "BJ",
  },
  {
    name: "Bermuda",
    countryCode: 60,
    abv: "BM",
  },
  {
    name: "Bhutan",
    countryCode: 64,
    abv: "BT",
  },
  {
    name: "Bolivia, Plurinational State of",
    countryCode: 68,
    abv: "BO",
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    countryCode: 535,
    abv: "BQ",
  },
  {
    name: "Bosnia and Herzegovina",
    countryCode: 70,
    abv: "BA",
  },
  {
    name: "Botswana",
    countryCode: 72,
    abv: "BW",
  },
  {
    name: "Bouvet Island",
    countryCode: 74,
    abv: "BV",
  },
  {
    name: "Brazil",
    countryCode: 76,
    abv: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    countryCode: 86,
    abv: "IO",
  },
  {
    name: "Brunei Darussalam",
    countryCode: 96,
    abv: "BN",
  },
  {
    name: "Bulgaria",
    countryCode: 100,
    abv: "BG",
  },
  {
    name: "Burkina Faso",
    countryCode: 854,
    abv: "BF",
  },
  {
    name: "Burundi",
    countryCode: 108,
    abv: "BI",
  },
  {
    name: "Cabo Verde",
    countryCode: 132,
    abv: "CV",
  },
  {
    name: "Cambodia",
    countryCode: 116,
    abv: "KH",
  },
  {
    name: "Cameroon",
    countryCode: 120,
    abv: "CM",
  },
  {
    name: "Canada",
    countryCode: 124,
    abv: "CA",
  },
  {
    name: "Cayman Islands",
    countryCode: 136,
    abv: "KY",
  },
  {
    name: "Central African Republic",
    countryCode: 140,
    abv: "CF",
  },
  {
    name: "Chad",
    countryCode: 148,
    abv: "TD",
  },
  {
    name: "Chile",
    countryCode: 152,
    abv: "CL",
  },
  {
    name: "China",
    countryCode: 156,
    abv: "CN",
  },
  {
    name: "Christmas Island",
    countryCode: 162,
    abv: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",
    countryCode: 166,
    abv: "CC",
  },
  {
    name: "Colombia",
    countryCode: 170,
    abv: "CO",
  },
  {
    name: "Comoros",
    countryCode: 174,
    abv: "KM",
  },
  {
    name: "Congo",
    countryCode: 178,
    abv: "CG",
  },
  {
    name: "Congo, Democratic Republic of the",
    countryCode: 180,
    abv: "CD",
  },
  {
    name: "Cook Islands",
    countryCode: 184,
    abv: "CK",
  },
  {
    name: "Costa Rica",
    countryCode: 188,
    abv: "CR",
  },
  {
    name: "Côte d'Ivoire",
    countryCode: 384,
    abv: "CI",
  },
  {
    name: "Croatia",
    countryCode: 191,
    abv: "HR",
  },
  {
    name: "Cuba",
    countryCode: 192,
    abv: "CU",
  },
  {
    name: "Curaçao",
    countryCode: 531,
    abv: "CW",
  },
  {
    name: "Cyprus",
    countryCode: 196,
    abv: "CY",
  },
  {
    name: "Czechia",
    countryCode: 203,
    abv: "CZ",
  },
  {
    name: "Denmark",
    countryCode: 208,
    abv: "DK",
  },
  {
    name: "Djibouti",
    countryCode: 262,
    abv: "DJ",
  },
  {
    name: "Dominica",
    countryCode: 212,
    abv: "DM",
  },
  {
    name: "Dominican Republic",
    countryCode: 214,
    abv: "DO",
  },
  {
    name: "Ecuador",
    countryCode: 218,
    abv: "EC",
  },
  {
    name: "Egypt",
    countryCode: 818,
    abv: "EG",
  },
  {
    name: "El Salvador",
    countryCode: 222,
    abv: "SV",
  },
  {
    name: "Equatorial Guinea",
    countryCode: 226,
    abv: "GQ",
  },
  {
    name: "Eritrea",
    countryCode: 232,
    abv: "ER",
  },
  {
    name: "Estonia",
    countryCode: 233,
    abv: "EE",
  },
  {
    name: "Eswatini",
    countryCode: 748,
    abv: "SZ",
  },
  {
    name: "Ethiopia",
    countryCode: 231,
    abv: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",
    countryCode: 238,
    abv: "FK",
  },
  {
    name: "Faroe Islands",
    countryCode: 234,
    abv: "FO",
  },
  {
    name: "Fiji",
    countryCode: 242,
    abv: "FJ",
  },
  {
    name: "Finland",
    countryCode: 246,
    abv: "FI",
  },
  {
    name: "France",
    countryCode: 250,
    abv: "FR",
  },
  {
    name: "French Guiana",
    countryCode: 254,
    abv: "GF",
  },
  {
    name: "French Polynesia",
    countryCode: 258,
    abv: "PF",
  },
  {
    name: "French Southern Territories",
    countryCode: 260,
    abv: "TF",
  },
  {
    name: "Gabon",
    countryCode: 266,
    abv: "GA",
  },
  {
    name: "Gambia",
    countryCode: 270,
    abv: "GM",
  },
  {
    name: "Georgia",
    countryCode: 268,
    abv: "GE",
  },
  {
    name: "Germany",
    countryCode: 276,
    abv: "DE",
  },
  {
    name: "Ghana",
    countryCode: 288,
    abv: "GH",
  },
  {
    name: "Gibraltar",
    countryCode: 292,
    abv: "GI",
  },
  {
    name: "Greece",
    countryCode: 300,
    abv: "GR",
  },
  {
    name: "Greenland",
    countryCode: 304,
    abv: "GL",
  },
  {
    name: "Grenada",
    countryCode: 308,
    abv: "GD",
  },
  {
    name: "Guadeloupe",
    countryCode: 312,
    abv: "GP",
  },
  {
    name: "Guam",
    countryCode: 316,
    abv: "GU",
  },
  {
    name: "Guatemala",
    countryCode: 320,
    abv: "GT",
  },
  {
    name: "Guernsey",
    countryCode: 831,
    abv: "GG",
  },
  {
    name: "Guinea",
    countryCode: 324,
    abv: "GN",
  },
  {
    name: "Guinea-Bissau",
    countryCode: 624,
    abv: "GW",
  },
  {
    name: "Guyana",
    countryCode: 328,
    abv: "GY",
  },
  {
    name: "Haiti",
    countryCode: 332,
    abv: "HT",
  },
  {
    name: "Heard Island and McDonald Islands",
    countryCode: 334,
    abv: "HM",
  },
  {
    name: "Holy See",
    countryCode: 336,
    abv: "VA",
  },
  {
    name: "Honduras",
    countryCode: 340,
    abv: "HN",
  },
  {
    name: "Hong Kong",
    countryCode: 344,
    abv: "HK",
  },
  {
    name: "Hungary",
    countryCode: 348,
    abv: "HU",
  },
  {
    name: "Iceland",
    countryCode: 352,
    abv: "IS",
  },
  {
    name: "India",
    countryCode: 356,
    abv: "IN",
  },
  {
    name: "Indonesia",
    countryCode: 360,
    abv: "ID",
  },
  {
    name: "Iran, Islamic Republic of",
    countryCode: 364,
    abv: "IR",
  },
  {
    name: "Iraq",
    countryCode: 368,
    abv: "IQ",
  },
  {
    name: "Ireland",
    countryCode: 372,
    abv: "IE",
  },
  {
    name: "Isle of Man",
    countryCode: 833,
    abv: "IM",
  },
  {
    name: "Israel",
    countryCode: 376,
    abv: "IL",
  },
  {
    name: "Italy",
    countryCode: 380,
    abv: "IT",
  },
  {
    name: "Jamaica",
    countryCode: 388,
    abv: "JM",
  },
  {
    name: "Japan",
    countryCode: 392,
    abv: "JP",
  },
  {
    name: "Jersey",
    countryCode: 832,
    abv: "JE",
  },
  {
    name: "Jordan",
    countryCode: 400,
    abv: "JO",
  },
  {
    name: "Kazakhstan",
    countryCode: 398,
    abv: "KZ",
  },
  {
    name: "Kenya",
    countryCode: 404,
    abv: "KE",
  },
  {
    name: "Kiribati",
    countryCode: 296,
    abv: "KI",
  },
  {
    name: "Korea, Democratic People's Republic of",
    countryCode: 408,
    abv: "KP",
  },
  {
    name: "Korea, Republic of",
    countryCode: 410,
    abv: "KR",
  },
  {
    name: "Kuwait",
    countryCode: 414,
    abv: "KW",
  },
  {
    name: "Kyrgyzstan",
    countryCode: 417,
    abv: "KG",
  },
  {
    name: "Lao People's Democratic Republic",
    countryCode: 418,
    abv: "LA",
  },
  {
    name: "Latvia",
    countryCode: 428,
    abv: "LV",
  },
  {
    name: "Lebanon",
    countryCode: 422,
    abv: "LB",
  },
  {
    name: "Lesotho",
    countryCode: 426,
    abv: "LS",
  },
  {
    name: "Liberia",
    countryCode: 430,
    abv: "LR",
  },
  {
    name: "Libya",
    countryCode: 434,
    abv: "LY",
  },
  {
    name: "Liechtenstein",
    countryCode: 438,
    abv: "LI",
  },
  {
    name: "Lithuania",
    countryCode: 440,
    abv: "LT",
  },
  {
    name: "Luxembourg",
    countryCode: 442,
    abv: "LU",
  },
  {
    name: "Macao",
    countryCode: 446,
    abv: "MO",
  },
  {
    name: "Madagascar",
    countryCode: 450,
    abv: "MG",
  },
  {
    name: "Malawi",
    countryCode: 454,
    abv: "MW",
  },
  {
    name: "Malaysia",
    countryCode: 458,
    abv: "MY",
  },
  {
    name: "Maldives",
    countryCode: 462,
    abv: "MV",
  },
  {
    name: "Mali",
    countryCode: 466,
    abv: "ML",
  },
  {
    name: "Malta",
    countryCode: 470,
    abv: "MT",
  },
  {
    name: "Marshall Islands",
    countryCode: 584,
    abv: "MH",
  },
  {
    name: "Martinique",
    countryCode: 474,
    abv: "MQ",
  },
  {
    name: "Mauritania",
    countryCode: 478,
    abv: "MR",
  },
  {
    name: "Mauritius",
    countryCode: 480,
    abv: "MU",
  },
  {
    name: "Mayotte",
    countryCode: 175,
    abv: "YT",
  },
  {
    name: "Mexico",
    countryCode: 484,
    abv: "MX",
  },
  {
    name: "Micronesia, Federated States of",
    countryCode: 583,
    abv: "FM",
  },
  {
    name: "Moldova, Republic of",
    countryCode: 498,
    abv: "MD",
  },
  {
    name: "Monaco",
    countryCode: 492,
    abv: "MC",
  },
  {
    name: "Mongolia",
    countryCode: 496,
    abv: "MN",
  },
  {
    name: "Montenegro",
    countryCode: 499,
    abv: "ME",
  },
  {
    name: "Montserrat",
    countryCode: 500,
    abv: "MS",
  },
  {
    name: "Morocco",
    countryCode: 504,
    abv: "MA",
  },
  {
    name: "Mozambique",
    countryCode: 508,
    abv: "MZ",
  },
  {
    name: "Myanmar",
    countryCode: 104,
    abv: "MM",
  },
  {
    name: "Namibia",
    countryCode: 516,
    abv: "NA",
  },
  {
    name: "Nauru",
    countryCode: 520,
    abv: "NR",
  },
  {
    name: "Nepal",
    countryCode: 524,
    abv: "NP",
  },
  {
    name: "Netherlands, Kingdom of the",
    countryCode: 528,
    abv: "NL",
  },
  {
    name: "New Caledonia",
    countryCode: 540,
    abv: "NC",
  },
  {
    name: "New Zealand",
    countryCode: 554,
    abv: "NZ",
  },
  {
    name: "Nicaragua",
    countryCode: 558,
    abv: "NI",
  },
  {
    name: "Niger",
    countryCode: 562,
    abv: "NE",
  },
  {
    name: "Nigeria",
    countryCode: 566,
    abv: "NG",
  },
  {
    name: "Niue",
    countryCode: 570,
    abv: "NU",
  },
  {
    name: "Norfolk Island",
    countryCode: 574,
    abv: "NF",
  },
  {
    name: "North Macedonia",
    countryCode: 807,
    abv: "MK",
  },
  {
    name: "Northern Mariana Islands",
    countryCode: 580,
    abv: "MP",
  },
  {
    name: "Norway",
    countryCode: 578,
    abv: "NO",
  },
  {
    name: "Oman",
    countryCode: 512,
    abv: "OM",
  },
  {
    name: "Pakistan",
    countryCode: 586,
    abv: "PK",
  },
  {
    name: "Palau",
    countryCode: 585,
    abv: "PW",
  },
  {
    name: "Palestine, State of",
    countryCode: 275,
    abv: "PS",
  },
  {
    name: "Panama",
    countryCode: 591,
    abv: "PA",
  },
  {
    name: "Papua New Guinea",
    countryCode: 598,
    abv: "PG",
  },
  {
    name: "Paraguay",
    countryCode: 600,
    abv: "PY",
  },
  {
    name: "Peru",
    countryCode: 604,
    abv: "PE",
  },
  {
    name: "Philippines",
    countryCode: 608,
    abv: "PH",
  },
  {
    name: "Pitcairn",
    countryCode: 612,
    abv: "PN",
  },
  {
    name: "Poland",
    countryCode: 616,
    abv: "PL",
  },
  {
    name: "Portugal",
    countryCode: 620,
    abv: "PT",
  },
  {
    name: "Puerto Rico",
    countryCode: 630,
    abv: "PR",
  },
  {
    name: "Qatar",
    countryCode: 634,
    abv: "QA",
  },
  {
    name: "Réunion",
    countryCode: 638,
    abv: "RE",
  },
  {
    name: "Romania",
    countryCode: 642,
    abv: "RO",
  },
  {
    name: "Russian Federation",
    countryCode: 643,
    abv: "RU",
  },
  {
    name: "Rwanda",
    countryCode: 646,
    abv: "RW",
  },
  {
    name: "Saint Barthélemy",
    countryCode: 652,
    abv: "BL",
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    countryCode: 654,
    abv: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    countryCode: 659,
    abv: "KN",
  },
  {
    name: "Saint Lucia",
    countryCode: 662,
    abv: "LC",
  },
  {
    name: "Saint Martin (French part)",
    countryCode: 663,
    abv: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",
    countryCode: 666,
    abv: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    countryCode: 670,
    abv: "VC",
  },
  {
    name: "Samoa",
    countryCode: 882,
    abv: "WS",
  },
  {
    name: "San Marino",
    countryCode: 674,
    abv: "SM",
  },
  {
    name: "Sao Tome and Principe",
    countryCode: 678,
    abv: "ST",
  },
  {
    name: "Saudi Arabia",
    countryCode: 682,
    abv: "SA",
  },
  {
    name: "Senegal",
    countryCode: 686,
    abv: "SN",
  },
  {
    name: "Serbia",
    countryCode: 688,
    abv: "RS",
  },
  {
    name: "Seychelles",
    countryCode: 690,
    abv: "SC",
  },
  {
    name: "Sierra Leone",
    countryCode: 694,
    abv: "SL",
  },
  {
    name: "Singapore",
    countryCode: 702,
    abv: "SG",
  },
  {
    name: "Sint Maarten (Dutch part)",
    countryCode: 534,
    abv: "SX",
  },
  {
    name: "Slovakia",
    countryCode: 703,
    abv: "SK",
  },
  {
    name: "Slovenia",
    countryCode: 705,
    abv: "SI",
  },
  {
    name: "Solomon Islands",
    countryCode: 90,
    abv: "SB",
  },
  {
    name: "Somalia",
    countryCode: 706,
    abv: "SO",
  },
  {
    name: "South Africa",
    countryCode: 710,
    abv: "ZA",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    countryCode: 239,
    abv: "GS",
  },
  {
    name: "South Sudan",
    countryCode: 728,
    abv: "SS",
  },
  {
    name: "Spain",
    countryCode: 724,
    abv: "ES",
  },
  {
    name: "Sri Lanka",
    countryCode: 144,
    abv: "LK",
  },
  {
    name: "Sudan",
    countryCode: 729,
    abv: "SD",
  },
  {
    name: "Suriname",
    countryCode: 740,
    abv: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    countryCode: 744,
    abv: "SJ",
  },
  {
    name: "Sweden",
    countryCode: 752,
    abv: "SE",
  },
  {
    name: "Switzerland",
    countryCode: 756,
    abv: "CH",
  },
  {
    name: "Syrian Arab Republic",
    countryCode: 760,
    abv: "SY",
  },
  {
    name: "Taiwan, Province of China",
    countryCode: 158,
    abv: "TW",
  },
  {
    name: "Tajikistan",
    countryCode: 762,
    abv: "TJ",
  },
  {
    name: "Tanzania, United Republic of",
    countryCode: 834,
    abv: "TZ",
  },
  {
    name: "Thailand",
    countryCode: 764,
    abv: "TH",
  },
  {
    name: "Timor-Leste",
    countryCode: 626,
    abv: "TL",
  },
  {
    name: "Togo",
    countryCode: 768,
    abv: "TG",
  },
  {
    name: "Tokelau",
    countryCode: 772,
    abv: "TK",
  },
  {
    name: "Tonga",
    countryCode: 776,
    abv: "TO",
  },
  {
    name: "Trinidad and Tobago",
    countryCode: 780,
    abv: "TT",
  },
  {
    name: "Tunisia",
    countryCode: 788,
    abv: "TN",
  },
  {
    name: "Türkiye",
    countryCode: 792,
    abv: "TR",
  },
  {
    name: "Turkmenistan",
    countryCode: 795,
    abv: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    countryCode: 796,
    abv: "TC",
  },
  {
    name: "Tuvalu",
    countryCode: 798,
    abv: "TV",
  },
  {
    name: "Uganda",
    countryCode: 800,
    abv: "UG",
  },
  {
    name: "Ukraine",
    countryCode: 804,
    abv: "UA",
  },
  {
    name: "United Arab Emirates",
    countryCode: 784,
    abv: "AE",
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    countryCode: 826,
    abv: "GB",
  },
  {
    name: "United States of America",
    countryCode: 840,
    abv: "US",
  },
  {
    name: "United States Minor Outlying Islands",
    countryCode: 581,
    abv: "UM",
  },
  {
    name: "Uruguay",
    countryCode: 858,
    abv: "UY",
  },
  {
    name: "Uzbekistan",
    countryCode: 860,
    abv: "UZ",
  },
  {
    name: "Vanuatu",
    countryCode: 548,
    abv: "VU",
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    countryCode: 862,
    abv: "VE",
  },
  {
    name: "Viet Nam",
    countryCode: 704,
    abv: "VN",
  },
  {
    name: "Virgin Islands (British)",
    countryCode: 92,
    abv: "VG",
  },
  {
    name: "Virgin Islands (U.S.)",
    countryCode: 850,
    abv: "VI",
  },
  {
    name: "Wallis and Futuna",
    countryCode: 876,
    abv: "WF",
  },
  {
    name: "Western Sahara",
    countryCode: 732,
    abv: "EH",
  },
  {
    name: "Yemen",
    countryCode: 887,
    abv: "YE",
  },
  {
    name: "Zambia",
    countryCode: 894,
    abv: "ZM",
  },
  {
    name: "Zimbabwe",
    countryCode: 716,
    abv: "ZW",
  },
];
